import {
  NlpIntent,
  NlpModel,
  PromptStepSchema,
  QuestionStepSchema,
  StepNlpConfiguration,
  StepSchema,
  SynonymGrammar
} from '@feedyou/schema'
import { expandSynonymsByGrammars } from './expandSynonymsByGrammars'
import { isNotEmptyElement } from '../array'
import { escapeRegExp } from '../regex'

const SINGLE_MATCH_PROMPT = `
  Jsi klasifikátor uživatelských dotazů. Uživatel vloží dotaz a tvým úkolem je vyhodnotit jeho úmysl / intent a vrátit jeho ID jako první prvek v poli "intents" ve výsledném JSONu. Pokud dotaz odpovídá více intentům, vrať vždy jen ten JEDEN ke kterému pasuje nejvíc.

  Nevymýšlej si, pokud si nejsi jistý tak nevracej nic.

  {{#intents}}
  Spusť intent ID {{id}}, pokud {{description}}.
  {{/intents}}
`

const MULTI_MATCH_PROMPT = `
  Jsi klasifikátor uživatelských dotazů. Uživatel vloží dotaz a tvým úkolem je vyhodnotit jeho úmysl / intent a vrátit jeho ID jako první prvek v poli "intents" ve výsledném JSONu.

  Pokud dotaz odpovídá více intentům, vrať ID všech relevantních intentů jako pole v property "intents" ve výsledném JSONu.

  Dále pokud jich je víc, tak připoj property "multiQuestion", do které sestav text dotazu na uživatele, kterým se ho zeptáš který právě JEDEN z nalezených intentů chce s tím, že:
    a) nemůže jich nikdy vybrat víc najednou,
    b) k dotazu využívej primárně pouze popis intentu (nikoliv jeho ID), nikoli přímo text dotazu uživatele.
    
  Nevymýšlej si a pokud si nejsi jistý, tak nevracej nic.

  {{#intents}}
  Spusť intent ID {{id}}, pokud {{description}}.
  {{/intents}}
`

export const convertQuestionLikeStepToNlpModel = (
  step: QuestionStepSchema | PromptStepSchema,
  config: StepNlpConfiguration | undefined,
  grammars: SynonymGrammar[] = []
): NlpModel | null => {
  if (!config) {
    return null
  }

  const { provider } = config

  const intents = (step.answers as Array<StepSchema['answers'][number]>)
    ?.filter(answer => !!answer.id)
    ?.filter(answer => !answer.disabled) // Disabled is static, so we can remove it for both training and evaluation for nlp.js
    ?.map(answer => {
      return {
        id: answer.id!,
        name: answer.answer,
        rules: [
          ...(answer.rules || []),
          {
            // exact answer itself (for example direct click on quickreply) should be always used as trigger
            regex: escapeRegExp(answer.answer || ''),
            type: 'trigger'
          }
        ],
        utterances:
          provider.type === 'feedyou'
            ? [answer.answer, ...expandSynonymsByGrammars(answer.synonyms, grammars)]?.filter(
                isNotEmptyElement
              )
            : undefined,
        description:
          provider.type === 'llm-classifier'
            ? answer.description || `dotaz významově odpovídá výrazu "${answer.answer}"`
            : undefined
      }
    })

  return {
    id: step.id,
    intents,
    provider:
      provider?.multiMode === 'llm-question'
        ? { prompt: provider.prompt || MULTI_MATCH_PROMPT, ...provider }
        : { prompt: provider.prompt || SINGLE_MATCH_PROMPT, ...provider }
  }
}
